// components/HeroSection.tsx
'use client'
import React from 'react';
import { Box, Text, Button, useDisclosure } from "@chakra-ui/react";
import { GoogleForm } from 'components';
import { useAppContext } from 'hooks';

const HeroSection = ({HeroText, HeroButtonText}: {HeroText: string, HeroButtonText: string}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { jwt } = useAppContext();

  return (
    <Box
      mt={{ base: "40px", md: "60px" }}
      textAlign="center"
      width="100%"
      flexShrink="0"
      bgGradient="linear(to-t, #5865F2 -196.62%, #050918 84.81%)"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={{ base: "10px", md: "20px" }}
      borderRadius="16px"
      color="white"
      p={{ base: "20px", md: "40px" }}
    >
      <Text fontSize={{ base: "24px", md: "36px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "32px", md: "48px", lg: "62.4px" }}>
        {HeroText}
      </Text>
      <GoogleForm isOpen={isOpen} onClose={onClose} />
      <Button
        mt={{ base: "10px", md: "20px" }}
        width={{ base: "180px", md: "228px" }}
        height="45px"
        padding="16px 24px"
        justifyContent="center"
        alignItems="center"
        gap="10px"
        borderRadius="16px"
        bg="#FF1B6D"
        color="white"
        _hover={{ opacity: 0.8 }}
        as="a"
        href={jwt ? "/dashboard" : "#"}
        onClick={!jwt ? onOpen : undefined}
      >
        {jwt ? 'Go to Dashboard' : HeroButtonText}
      </Button>
    </Box>
  );
};

export default HeroSection;
